"use strict";
import {find, on, closest} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import * as formValidation from '@elements/form-validation';

export function init() {
    onFind('.js-regex-select', select => {
        let target = find(select.getAttribute('data-regex-target')),
            defaultPattern = target.getAttribute('pattern'),
            defaultMessage = target.getAttribute('data-validation-regexp___message');

        formValidation.getApi(closest('form', select)).then((formApi) => {
            let formInstance = formApi.getFormInstance();

            setPattern(select, defaultPattern, defaultMessage, formInstance, target);


            on('change', () => {
                setPattern(select, defaultPattern, defaultMessage, formInstance, target);
            }, select);
        });
    });
}

function setPattern(select, defaultPattern, defaultMessage, formInstance, target) {
    let selectedOption = select.options[select.selectedIndex];

    let pattern = defaultPattern,
        message = defaultMessage;

    if (selectedOption.getAttribute('data-pattern')) {
        pattern = selectedOption.getAttribute('data-pattern');
        message = selectedOption.getAttribute('data-pattern-error-message');
    }

    formInstance.updateValidatorOption(target.getAttribute('name'), 'regexp', 'regexp', pattern).updateValidatorOption(target.getAttribute('name'), 'regexp', 'message', message).revalidateField(target.getAttribute('name'));
}